import * as React from "react";
import { RefObject } from "react";
import { renderMultilineText } from "../../../utils/text-rendering";
import InputProps from "../../../model/form/InputProps";
import FormInput from "./FormInput";
import { buildClasses } from "../../../utils/classes";
import EditAction from "../../action/EditAction";
import RemoveAction from "../../action/RemoveAction";
import InputState from "../../../model/form/InputState";

export default class TreatmentImageInput extends React.Component<InputProps> {
  private inputFileRef: RefObject<any> = React.createRef();

  constructor(props: InputProps) {
    super(props);
    this.template = this.template.bind(this);
    this.loadImage = this.loadImage.bind(this);
    this.openFileDialog = this.openFileDialog.bind(this);
  }

  template(state: InputState, input) {
    const availableActions = [];
    if (state.value) {
      availableActions.push(
        <EditAction key="edit" onClick={(e) => this.openFileDialog(e, input)} />
      );
      availableActions.push(
        <RemoveAction key="remove" onClick={() => (input.dirty(), input.setValue(null))} />
      );
    }

    return (
      <div
        className={buildClasses(
          { invalid: () => state.status.invalid && !state.status.pristine },
          "treatment-image-input"
        )}
      >
        <label>
          <span>{i18n["Global.Image"]}</span>
          <span className="detail">{i18n["Global.OptionalField"]}</span>
        </label>
        {state.value ? (
          <div className="picture">
            <img src={state.value} alt="treatment image" />
          </div>
        ) : (
          <div className="no-image">
            <div className="title">{i18n["TreatmentEditor.ImageEditor.NoImage.Title"]}</div>
            <div>{renderMultilineText(i18n["TreatmentEditor.ImageEditor.NoImage.Details"])}</div>
            <button
              type="button"
              className="button-primary"
              onClick={(e) => this.openFileDialog(e, input)}
            >
              {i18n["Global.Upload"]}
            </button>
          </div>
        )}
        {availableActions.length > 0 && (
          <div className="actions h-flex space-around">
            {availableActions.map((action) => action)}
          </div>
        )}
        <input
          ref={this.inputFileRef}
          type="file"
          className="none"
          onChange={(e) => this.loadImage(e, input)}
          accept="image/png,image/gif,image/jpeg"
        />
        <div
          className={buildClasses(
            { invalid: () => state.status.invalid && !state.status.pristine },
            "input-group"
          )}
        >
          <div className="error-message">{state.status.errorMessage}</div>
        </div>
      </div>
    );
  }

  openFileDialog(event, input) {
    event.preventDefault();
    input.dirty();
    this.inputFileRef.current.click();
  }

  loadImage(event, input) {
    if (event.target.files && event.target.files[0]) {
      if (event.target.files[0].size > 5_242_880) {
        input.setError(i18n["TreatmentEditor.ImageEditor.Error.FileTooBig"], true);
        return;
      }
      const reader = new FileReader();
      reader.onload = (fileEvent) => {
        this.inputFileRef.current.value = null;
        input.setValue(fileEvent.target["result"]);
      };
      reader.readAsDataURL(event.target.files[0]);
    }
  }

  render() {
    return <FormInput {...this.props} template={this.template} />;
  }
}
